import { TextDOMPurify } from "Services/Sanitization";

import { highlightMatches } from "../helper";

import styles from "./SpotlightInAppActionItem.module.scss";

type SpotlightRoutingItemProps = {
    name: string;
    description: string;
    searchValue: string;
    onCallback: () => void;
    icon: React.ReactNode;
};

export function SpotlightInAppActionItem({
    name,
    description,
    searchValue,
    onCallback,
    icon,
}: SpotlightRoutingItemProps): JSX.Element {
    return (
        <div
            className={styles.spotlightItem}
            onClick={() => {
                onCallback();
            }}
        >
            <div>{icon}</div>
            <div>
                <div className={styles.routeContainer}>
                    <div
                        className={styles.name}
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: TextDOMPurify.sanitize(searchValue ? highlightMatches(name, searchValue) : name),
                        }}
                    ></div>
                </div>
                <div
                    className={styles.description}
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: TextDOMPurify.sanitize(
                            searchValue ? highlightMatches(description, searchValue) : description
                        ),
                    }}
                ></div>
            </div>
        </div>
    );
}
